import {
  CLINIC_LIST,
  ADD_CLINIC,

  REMOVE_CLINIC,
  USERS_CLINIC,
  REMOVE_USER_CLINIC,
  GET_CLINIC_DETAILS,
  PATIENTS_LIST,
  SET_ERROR
} from "./types";

import { authAxios } from "../../utils/AxiosHelper";
import { fillPatientsBuckets } from "../../utils/CFuncs";
import { navigateTo, setError, setIsLoading, setSuccess } from "./";







const checkUserConfirmation = (token, clinicId) => {
  return (dispatch) => {
    console.log(authAxios.defaults.headers.common.Authorization);
    let path = `/token/${token}/clinic/${clinicId}`;

    authAxios
      .get(path)
      .then((response) => {
        if (response.data === true) {
        }
      })
      .catch((error) => {
        dispatch({ type: PATIENTS_LIST, payload: { error } });
      });
  };
};

const handleErrorResponse = (error, dispatch,type) => {
  console.log("erro messaeg ");

  console.log(error.message);
  let errObj = error.response?.data?.errors;
  if (errObj && Object.keys(errObj).length > 0) {
    return dispatch({
      type,
      payload: Object.values(errObj).join(" "),
    });
  } else if (error.response) {
    const errorMessage = typeof error.response.data == 'string' ? error.response.data : error.response.data.error
    return dispatch({
      type,
      payload: errorMessage,
    });
  } else if (error.request) {
    console.log(error.request);
    return dispatch({ type, payload: error.request });
  } else {
    return dispatch({ type, payload: error.message });
  }
};

export const getClinics = () => {
  const path = `clinics`;
  return (dispatch) => {
    dispatch(setIsLoading(true))

    return authAxios
      .get(path)
      .then((response) => {
        console.log(response.data);
      dispatch(setIsLoading(false))

        return dispatch({ type: CLINIC_LIST, payload: response.data });
      })
      .catch((error) => {
      dispatch(setIsLoading(false))

        handleErrorResponse(error, dispatch,SET_ERROR);
      });
  };
};

export const addClinic = (clinicToAdd,callback=()=>{}) => {
  console.log('addClinic started');
  let path = `clinics`;
  return (dispatch) => {
    return authAxios
    .post(path, clinicToAdd)
    .then((response) => {
      dispatch(setSuccess("Clinics added successfully"));

      
      callback()
        return dispatch({ type: ADD_CLINIC, payload: response.data });
      })
      .catch((error) => {
        return handleErrorResponse(error, dispatch,SET_ERROR);
      });
  };
};

export const removeUser = (user,clinicId) => {
  let path = `clinics/${clinicId}/user`;
  return (dispatch) => {
    return authAxios
      .delete(path, { data: user })
      .then((response) => {
        dispatch(setSuccess("User removed successfully"));
        return dispatch({
          type: REMOVE_USER_CLINIC,
          payload: response.data,
        });

      })
      .catch((error) => {
        handleErrorResponse(error, dispatch,SET_ERROR);
      });
  };
};

// export const removePaitent = (paitentId) => {
//   let path = `users`;
//   return (dispatch) => {
//     return authAxios

//       .delete(path)
//       .then((response) => {
//         return dispatch({
//           type: REMOVE_PAITENT_CLINIC,
//           payload: response.data,
//         });
//       })
//       .catch((error) => {
//         handleErrorResponse(error, dispatch,SET_ERROR);
//       });
//   };
// };

export const removeClinic = (clinicid) => {
  return (dispatch, getState) => {
    let path = `clinics/${clinicid}`;
    return authAxios
      .delete(path)
      .then((response) => {
        dispatch(setSuccess("Cliinc has been removed successfully"))
        return dispatch({ type: REMOVE_CLINIC, payload: clinicid });

      })
      .catch((error) => {
        handleErrorResponse(error, dispatch,SET_ERROR);
      });
  };
};
export const editClinic = (clinicToEdit,callback=()=>{}) => {
  let path = `clinics`;
  return (dispatch) => {
    return authAxios
    .put(path, clinicToEdit)
    .then((response) => {
      console.log(response.data);
      console.log('editClinic done')
      dispatch(getClinicData(clinicToEdit.id))
      dispatch(setSuccess("Clinic has Edited successfully"))


        callback()
        dispatch(setError(""))
      })
      .catch((error) => {
        handleErrorResponse(error, dispatch,SET_ERROR);
      });
  };
};

export const getClinicData = (clinicId) => {
  return (dispatch) => {

  let path = `clinics/${clinicId}`;
  return authAxios
    .get(path)
    .then((response) => {
      console.log(response.data);
      
      return dispatch({ type: GET_CLINIC_DETAILS, payload: response.data });

    })
    .catch((error) => {
      console.log(error.response);
      // throw error;
      handleErrorResponse(error, dispatch,SET_ERROR);

    });
  }
};


export const addUserToClinic = (clinicId, user, callback = () => {}) => {
  console.log('addUserToClinic started')
  console.log(user)
  return (dispatch) => {
    authAxios
    .post(`/clinics/${clinicId}/users`, user)
    .then((response) => {
      console.log(response.data);
      console.log('addUserToClinic started done')
      dispatch(setSuccess("User added successfully"))
        dispatch(getUsers());
        callback();
      })
      .catch((error) => {
        // Handle the error response
        console.error("Error adding user:", error);
        handleErrorResponse(error, dispatch,SET_ERROR);
      });
  };
};

export const getUsers = () => {
  console.log('getUsers statred');
  
  return (dispatch) => {
    dispatch(setIsLoading(true))
    authAxios
    .get(`/clinics/users`)
    .then((response) => {
        console.log('getUsers done');
        console.log(response.data);
    dispatch(setIsLoading(false))
    
    return dispatch({ type: USERS_CLINIC, payload: response.data });
  })
  .catch((error) => {
    console.log('getUsers fail');
    dispatch(setIsLoading(false))
    
          // navigateTo(urls.clinicDetails)
        
        console.error("Error get the users:", error);
        handleErrorResponse(error, dispatch,SET_ERROR);
      });
  };
};


export const getUsersByClinicId = (clincId) => {
  
  console.log('getUsers statred');
  return (dispatch) => {
    dispatch(setIsLoading(true))
    authAxios
    .get(`/clinics/${clincId}/users`)
    .then((response) => {
      console.log('getUsers done');
      console.log(response.data);
      
      
      dispatch(setIsLoading(false))
      return dispatch({ type: USERS_CLINIC, payload: response.data });
    })
    .catch((error) => {
      console.log('getUsers fail');
      
      // navigateTo(urls.clinicDetails)
      
      dispatch(setIsLoading(false))
        console.error("Error get the users:", error);
        handleErrorResponse(error, dispatch,SET_ERROR);
      });
  };
};

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

//  get that per clinick id
export const getPatients = () => {
  console.log("getPatients");

  return (dispatch) => {
        dispatch(setIsLoading(true))

    console.log(authAxios.defaults.headers.common.Authorization);
    let path = `/clinics/patients/cobb`;
    
    authAxios
    .get(path)
    .then((response) => {
      let list = response.data != null ? response.data : [];
      dispatch({
        type: PATIENTS_LIST,
        payload: fillPatientsBuckets(list),
      });
          dispatch(setIsLoading(false))

    })
    .catch((error) => {
      console.log("getPatients  erro");
      console.log({ error });
          dispatch(setIsLoading(false))

            dispatch(navigateTo("/"));

            // dispatch({ type: PATIENTS_LIST, payload: { error } })
          });
        }
};

export const getPatientsByClinicId = (clinicid) => {
  console.log("getPatientsByClinicId");

  return (dispatch) => {
        let path = `/clinics/${clinicid}/patients/cobb`;
            dispatch(setIsLoading(true))

        authAxios
        .get(path)
        .then((response) => {
          let list = response.data != null ? response.data : [];
          dispatch({
            type: PATIENTS_LIST,
            payload: fillPatientsBuckets(list),
          });
              dispatch(setIsLoading(false))

        })
        .catch((error) => {
              dispatch(setIsLoading(false))

            //if code 401 call refresh token
            console.log("getPatients  erro");
            console.log({ error });
            dispatch(navigateTo("/"));
          });
        }
};


export const setSelectedClinic = (clinic) => {
  console.log("setSelectedClinic");
 
    return (dispatch) => {
      dispatch({ type: GET_CLINIC_DETAILS, payload: clinic });
    }
  };


    export const setPatientsList = (list) => {
      console.log("setPatientsList");
        return (dispatch) => {
          dispatch({ type: PATIENTS_LIST, payload: list });
        }
      };
    export const setUsersClinic = (payload) => {
      console.log("setPatientsList");
        return (dispatch) => {
          dispatch({ type: USERS_CLINIC, payload });
        }
      };
    
